import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/admin/account-relation`;

export const accountRelationService = {
    createAccountRelation: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/create-account-relation`, params)
            .then((response) => {
                return response.data;
            });
    },
    updateAccountRelation: async function (key: any, values: any) {
        return axios.put(`${GATEWAY_URL}/update-account-relation`, values)
            .then((response) => {
                return response.data;
            });
    },
    deleteAccountRelation: async function (params: any) {
        return axios.delete(`${GATEWAY_URL}/delete-account-relation`, {
            params
        }).then((response) => {
            return response.data;
        });
    },
    getAccountRelations: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/get-account-relations`, {
            params
        }).then((response) => {
            return response.data;
        });
    },
    approveAccountRelationRequest: async function (params: any) {
        return axios.put(`${GATEWAY_URL}/approve-account-relation-request`, params)
        .then((response) => {
            return response.data;
        });
    },
    rejectAccountRelationRequest: async function (params: any) {
        return axios.put(`${GATEWAY_URL}/reject-account-relation-request`, params)
        .then((response) => {
            return response.data;
        });
    },
    getRelationRequests: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/get-account-relation-requests`,  {
            params
        })
        .then((response) => {
            return response.data;
        });
    },
}